import { render, staticRenderFns } from "./overviewExamDialog.vue?vue&type=template&id=8d7e385e"
import script from "./overviewExamDialog.vue?vue&type=script&lang=js"
export * from "./overviewExamDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports